import moment from 'moment';

export function parseLocalDateTime(value: string | Date | null | undefined): Date | null {
  if (!value) {
    return null;
  }
  return moment(value).toDate();
}
